<template>
  <b-tab>
    <template #title>
      <span class="d-none d-sm-inline">Fines</span>
    </template>
    <b-container>
      <div class="mb-2 d-flex justify-content-between align-items-center">
        <b-button
          variant="success"
          @click="validateForm"
        >
          Save Fines Changes
        </b-button>
        <b-button
          variant="primary"
          @click="addNewFinesForm"
        >
          <span>Add new fine</span>

        </b-button>
      </div>
      <validation-observer
        v-for="(el, ind) in finesArr"
        :key="el.localId"
        :ref="`finesRef-${el.localId}`"
      >
        <b-form>
          <b-row
            class="pb-5 fines_form_style"
          >
            <b-col
              md="12"
              class="d-flex justify-content-end"
            >
              <b-button
                variant="flat"
                @click="deleteFinesForm(ind)"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="25"
                  style="color: #CE224D"
                />
              </b-button>
            </b-col>
            <b-col md="4">
              <validation-provider
                name="from"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="From"
                  :label-for="`from_${el.localId}`"
                >
                  <v-select
                    :id="`from_${el.localId}`"
                    v-model="el.from"
                    :options="tripStates"
                    :reduce="state => state.key"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <validation-provider
                name="action by"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Action By"
                  :label-for="`action-by${el.localId}`"
                >
                  <v-select
                    :id="`action-by${el.localId}`"
                    v-model="el.action_by"
                    :options="finesUsers"
                    :reduce="type => type.key"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <validation-provider
                name="target"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Target"
                  :label-for="`target${el.localId}`"
                >
                  <v-select
                    :id="`target${el.localId}`"
                    v-model="el.target"
                    :options="userType"
                    :reduce="target => target.key"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <validation-provider
                name="amount"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Amount"
                  :label-for="`amount${el.localId}`"
                >
                  <b-form-input
                    :id="`amount${el.localId}`"
                    v-model="el.fee_amount"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                name="to"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="To"
                  :label-for="`to${el.localId}`"
                >
                  <v-select
                    :id="`to${el.localId}`"
                    v-model="el.to"
                    :options="tripStates"
                    :reduce="state => state.key"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <validation-provider
                name="transaction type"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Transaction Type"
                  :label-for="`transaction${el.localId}`"
                >
                  <v-select
                    :id="`transaction${el.localId}`"
                    v-model="el.transaction_type_slug"
                    :options="transactionTypesList"
                    title="label"
                    :reduce="opt => opt.slug"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <validation-provider
                name="value"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Value"
                  :label-for="`value${el.localId}`"
                >
                  <b-form-input
                    :id="`value${el.localId}`"
                    v-model="el.value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="4"
            >
              <validation-provider
                name="metric"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Metric"
                  :label-for="`metric${el.localId}`"
                >
                  <v-select
                    :id="`metric${el.localId}`"
                    v-model="el.metric"
                    :options="metric"
                    :reduce="metric => metric.key"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <validation-provider
                name="source"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Source"
                  :label-for="`source${el.localId}`"
                >
                  <v-select
                    :id="`source${el.localId}`"
                    v-model="el.source"
                    :options="userType"
                    :reduce="source => source.key"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <validation-provider
                name="period"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Period"
                  :label-for="`period${el.localId}`"
                >
                  <b-form-input
                    :id="`period${el.localId}`"
                    v-model="el.fee_period"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>

            </b-col>

          </b-row>
        </b-form>
      </validation-observer>
    </b-container>

  </b-tab>
</template>

<script>
import {
  BTab, BContainer, BRow, BCol, BFormInput, BFormGroup, BForm, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import {
  tripStates, metric, userType, finesUsers,
} from '../../hooks/useStaticOptions'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import useValidateDynamicForm from '../../hooks/use-validate-dynamic-forms'

export default {
  components: {
    BTab,
    BContainer,
    BRow,
    BCol,
    BFormInput,
    vSelect,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BFormGroup,
    BForm,
  },
  props: {
    fines: {
      type: Array,
      default: () => [],
    },
    transactionTypesList: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const finesArr = ref([...props.fines.map(el => (
      { ...el, localId: Math.random().toString() }))])
    const canSaveChanges = ref(false)
    const addNewFinesForm = async () => {
      const tempfine = {
        localId: Math.random().toString(),
        from: '',
        to: '',
        action_by: '',
        fee_amount: '',
        metric: '',
        fee_period: '',
        source: '',
        target: '',
        transaction_type_slug: '',
        value: '',
      }
      finesArr.value.unshift(tempfine)
    }
    const deleteFinesForm = ind => {
      finesArr.value.splice(ind, 1)
    }

    const validateForm = async () => {
      const isValid = await useValidateDynamicForm(ctx)
      if (isValid) {
        ctx.emit('fines-set', finesArr.value)
        successNotification('Saved...')
      } else {
        errorNotification('Fill out the required fields')
      }
    }

    return {
      required,
      tripStates,
      metric,
      userType,
      validateForm,
      addNewFinesForm,
      deleteFinesForm,
      finesArr,
      canSaveChanges,
      finesUsers,
    }
  },
}
</script>

<style scoped>
.fines_form_style{
    border: 3px solid lightgray;
    padding: 20px;
    margin-bottom: 30px;
    border-radius: 20px;
}
</style>
